"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertMapper = alertMapper;
exports.alertTypeMapper = alertTypeMapper;
exports.alertTypeItemMapper = alertTypeItemMapper;
const models_1 = require("../models");
const ChatsMapper_1 = require("./ChatsMapper");
const UserInfoMapper_1 = require("./UserInfoMapper");
const MessageUtils_1 = require("./MessageUtils");
function alertMapper(alertResponse, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    return {
        priority: alertTypeMapper(alertResponse.priority, userDirectory, organizationUser, httpAdapter, socketAdapter),
        acknowledgement: alertTypeMapper(alertResponse.acknowledgement, userDirectory, organizationUser, httpAdapter, socketAdapter),
        sentAcknowledgement: alertTypeMapper(alertResponse.sentAcknowledgement, userDirectory, organizationUser, httpAdapter, socketAdapter),
        referral: alertTypeMapper(alertResponse.referral, userDirectory, organizationUser, httpAdapter, socketAdapter),
    };
}
function alertTypeMapper(alertTypeResponse, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    const alertTypeData = [];
    if (alertTypeResponse) {
        for (const data of alertTypeResponse.data) {
            alertTypeData.push(alertTypeItemMapper(data, userDirectory, organizationUser, httpAdapter, socketAdapter));
        }
    }
    return {
        data: alertTypeData,
        limit: alertTypeResponse.limit,
        hasNext: alertTypeResponse.hasNext,
        total: alertTypeResponse.total,
    };
}
function alertTypeItemMapper(alertTypeItemResponse, userDirectory, organizationUser, httpAdapter, socketAdapter) {
    var _a, _b;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ 
        // SENT_ACKNOWLEDGEMENT items omit every flat identity field the backend
        // sends for other alert types (_id included) and nest everything under
        // `message` instead — fall back to the message's own id so this alert
        // still gets a stable, unique alertId for dedup/list-keying purposes.
        alertId: (_a = alertTypeItemResponse._id) !== null && _a !== void 0 ? _a : (_b = alertTypeItemResponse.message) === null || _b === void 0 ? void 0 : _b.messageId, type: models_1.ALERT_TYPE[alertTypeItemResponse.type], from: alertTypeItemResponse.from, user: alertTypeItemResponse.user, chatType: models_1.CHAT_TYPE[alertTypeItemResponse.chatType], messageId: alertTypeItemResponse.messageId, notified: alertTypeItemResponse.notified, isArchived: alertTypeItemResponse.isArchived, createdAt: alertTypeItemResponse.createdAt, updatedAt: alertTypeItemResponse.updatedAt, status: models_1.MESSAGE_STATUS[alertTypeItemResponse.status] }, (alertTypeItemResponse.message && {
        message: (0, MessageUtils_1.makeMessage)(alertTypeItemResponse.message, userDirectory, organizationUser, httpAdapter, socketAdapter),
    })), { info: alertTypeItemResponse.chatType === models_1.CHAT_TYPE.PRIVATE &&
            alertTypeItemResponse.info
            ? (0, UserInfoMapper_1.userInfoMapper)(alertTypeItemResponse.info)
            : alertTypeItemResponse.groupInfo &&
                (0, ChatsMapper_1.groupInfoMapper)(alertTypeItemResponse.groupInfo, userDirectory, organizationUser, httpAdapter) }), (alertTypeItemResponse.referralId && {
        referralId: alertTypeItemResponse.referralId,
    })), (alertTypeItemResponse.referralMessage && {
        referralMessage: alertTypeItemResponse.referralMessage,
    })), { alertStatus: models_1.ALERT_STATUS.UNREAD });
}
